export default __webpack_public_path__ + "static/media/skylight_logo.db3850b5.png";